import { memo, useState } from "react";
import Name from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Name/Name";
import Highlight from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Highlight/Highlight";
import Demo from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Demo/Demo";
import PickupAndRefillLocation from "@coworker/apprestructured/src/task-management/components/PickupAndRefillLocation/PickupAndRefillLocation";
import Actions from "./Actions/Actions";
import { FixaInputField } from "@coworker/apprestructured/src/shared/wrappers/FixaInputField/FixaInputField";

function PickupAndRefillLocationDemo() {
  const [pickupLocation, setPickupLocation] = useState("Location A");
  const [refillLocation, setRefillLocation] = useState("Location B");
  return (
    <Demo>
      <Name>PickupAndRefillLocation</Name>
      <Highlight>
        <PickupAndRefillLocation
          pickupLocation={pickupLocation}
          refillLocation={refillLocation}
          hasSameLocation={pickupLocation === refillLocation}
        />
      </Highlight>
      <Actions>
        <FixaInputField
          label="pickupLocation"
          type="text"
          id="pickupandrefilllocationdemo-pickup"
          value={pickupLocation}
          onChange={(e) => setPickupLocation(e.target.value)}
        />
        <FixaInputField
          label="refillLocation"
          type="text"
          id="pickupandrefilllocationdemo-refill"
          value={refillLocation}
          onChange={(e) => setRefillLocation(e.target.value)}
        />
      </Actions>
    </Demo>
  );
}

export default memo(PickupAndRefillLocationDemo);
